<div *ngIf="allegato" class="p-2 badge rounded-pill bg-gray-light cursor-pointer">
  <i *ngIf="showDelete" class="fas fa-trash text-danger pr-2" (click)="askDelete(allegato)"></i>
  <div class="d-inline" (click)="open()">{{ allegato.nome }} <i class="fas fa-external-link-alt"></i></div>
</div>
